import styled from 'styled-components'
import dynamic from 'next/dynamic'
import useNearScreen from 'hooks/use-near-screen'
import { simpleDottedBackground } from 'projects/background/background-patron'

const WeeklyProjectsStyled = styled.div`
  position: relative;
  img {
    width: 100%;
    height: auto;
  }
  &::before {
    right: -16px;
    left: -16px;
    height: 530px;
    transform: rotate(180deg);
    bottom: -530px;
  }
  ${simpleDottedBackground}
  @media(min-width: 768px) {
    &::before {
      display: none;
    }
  }
`

const CubesLazy = dynamic(
  () => import('../animations/cubes'),
)

function WeeklyProjects() {
  const [show, element] = useNearScreen({ rootMargin: '0px 0px 400px 0px' })
  return (
    <WeeklyProjectsStyled ref={element}>
      <picture className="img">
        <source srcSet="/images/projects/landing/weekly-projects.webp" type="image/webp" />
        <source srcSet="/images/projects/landing/weekly-projects.png" type="image/png" />
        <img
          src="/images/projects/landing/weekly-projects.png"
          width="472"
          height="816"
          loading="lazy"
          alt="Crea proyectos nuevos y practica cada semana"
        />
      </picture>
      {show && <CubesLazy />}
    </WeeklyProjectsStyled>
  )
}

export default WeeklyProjects
